import { h } from '@stencil/core';
import { generateSrcSet, generateMedia, pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
export class SdlSubCategoryBanner {
  constructor() {
    this.subcategoryPromoBlocksData = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderLogo(obj) {
    var _a, _b, _c, _d, _e;
    if ((obj === null || obj === void 0 ? void 0 : obj.image.MimeType) === 'image/svg+xml') {
      return (h("div", { class: "subcategory-promo-blocks__logo-block" }, h("img", { src: (_a = obj === null || obj === void 0 ? void 0 : obj.image) === null || _a === void 0 ? void 0 : _a.Url, alt: (_b = obj === null || obj === void 0 ? void 0 : obj.image) === null || _b === void 0 ? void 0 : _b.altText })));
    }
    return (h("div", { class: "subcategory-promo-blocks__logo-block" }, h("picture", { class: "subcategory-promo-blocks__logo-block-picture" }, (_c = obj === null || obj === void 0 ? void 0 : obj.image) === null || _c === void 0 ? void 0 :
      _c.imageSourceSets.map(({ minWidth, maxWidth, urls }) => (h("source", { media: generateMedia(minWidth, maxWidth), srcSet: generateSrcSet(urls) }))), h("img", { src: (_d = obj === null || obj === void 0 ? void 0 : obj.image) === null || _d === void 0 ? void 0 : _d.Url, alt: (_e = obj === null || obj === void 0 ? void 0 : obj.image) === null || _e === void 0 ? void 0 : _e.altText }))));
  }
  render() {
    var _a, _b;
    return (_b = (_a = this.subcategoryPromoBlocksData) === null || _a === void 0 ? void 0 : _a.slides) === null || _b === void 0 ? void 0 : _b.map((banner) => {
      var _a, _b, _c, _d;
      return (h("div", { class: "subcategory-promo-blocks" }, h("div", { class: "subcategory-promo-blocks__wrapper" }, h("div", { class: "subcategory-promo-blocks__image-wrap" }, h("picture", { class: "subcategory-promo-blocks__picture" }, (_b = (_a = banner === null || banner === void 0 ? void 0 : banner.image) === null || _a === void 0 ? void 0 : _a.imageSourceSets) === null || _b === void 0 ? void 0 :
        _b.map(({ minWidth, maxWidth, urls }) => (h("source", { media: generateMedia(minWidth, maxWidth), srcSet: generateSrcSet(urls) }))), h("img", { src: (_c = banner === null || banner === void 0 ? void 0 : banner.image) === null || _c === void 0 ? void 0 : _c.Url, alt: (_d = banner === null || banner === void 0 ? void 0 : banner.image) === null || _d === void 0 ? void 0 : _d.altText }))), h("div", { class: "subcategory-promo-blocks__context" }, h("h3", null, banner === null || banner === void 0 ? void 0 : banner.title), (banner === null || banner === void 0 ? void 0 : banner.description) && (h("p", { class: "subcategory-promo-blocks__context-description" }, banner === null || banner === void 0 ? void 0 : banner.description)), banner === null || banner === void 0 ? void 0 :
        banner.callToAction.map((action) => {
          if (!(action === null || action === void 0 ? void 0 : action.image) && ((action === null || action === void 0 ? void 0 : action.externalUrl) || (action === null || action === void 0 ? void 0 : action.youTubeEmbedUrl))) {
            return (h("div", null, h("a", { class: "subcategory-promo-blocks__context-link", href: (action === null || action === void 0 ? void 0 : action.externalUrl) || (action === null || action === void 0 ? void 0 : action.youTubeEmbedUrl), target: (action === null || action === void 0 ? void 0 : action.openInNewWindow) ? '_blank' : '_self' }, action === null || action === void 0 ? void 0 : action.text), h("pes-icon", { class: "subcategory-promo-blocks__context-link-icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")));
          }
          if (action === null || action === void 0 ? void 0 : action.image) {
            return this.renderLogo(action);
          }
          return null;
        })))));
    });
  }
  static get is() { return "pes-subcategory-promo-blocks"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["subcategory-promo-blocks.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["subcategory-promo-blocks.css"]
    };
  }
  static get properties() {
    return {
      "subcategoryPromoBlocksData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "SubcategoryPromoBlocks",
          "resolved": "{ buttonName: string; slides: SlideForBanner[]; tipDescription: any; tipTitle: any; contentType: ContentType; categoryId: string[]; nvdaNavigationLabel: NvdaNavigationLabel; }",
          "references": {
            "SubcategoryPromoBlocks": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get elementRef() { return "el"; }
}
